import { mutatorAction } from 'satcheljs';
import { inlineFeedbackDialogStore } from '../store/store';

export let setInlineFeedbackResponseText = mutatorAction(
    'setInlineFeedbackResponseText',
    (inlineFeedbackResponseText: string) => {
        let store = inlineFeedbackDialogStore();
        store.inlineFeedbackResponseText = inlineFeedbackResponseText;
    }
);
